/** @format */

import React from "react";
import { Card } from "react-bootstrap";
import { Trans, useTranslation } from "react-i18next";

const Home: React.FC = () => {
  const { t: _ } = useTranslation();
  return (
    <div className="PageNotFound m-5 col text-center">
      <Card border="light" className="p-4 shadow">
        <Card.Body>
          <h3>{_("No resource has been selected.")}</h3>
          <p>
            <Trans i18nKey="linkToFilter.msg">
              <a href={_("linkToFilter.link")} target="_blank" rel="noreferrer">
                link
              </a>
            </Trans>
          </p>
        </Card.Body>
      </Card>
    </div>
  );
};

export default Home;
